/**
 *  歷史紀錄弹窗
 * @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/14      1.0     Second version   统一调用组件
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 * */
import React  from 'react'
import {Modal, Spin,Button,message} from 'antd';
import Lang from "@components/Lang/Lang";
import dayjs from "dayjs";
import ShipperManagementAction from "../../../ShipperManagement.action";

export default class HistoryBtnModal extends React.Component{
    static defaultProps = {
        showRecover: false,
        recoverUrl:''
    };
    constructor(props) {
        super(props);
        this.state = {
            downloadLang:'',
            visible:false,
            loadingDownload:false,
            //历史记录
            loadingHistory:false,
            historyTitle:'',
            historyList:[],
        }
    }
    /**
     * 展示历史记录
     **/
    showHistory(orderType='',containerId=''){
        this.setState({
            visible:true,
            loadingHistory:true
        },()=>{
            ShipperManagementAction.getHistoryList({
                orderType: orderType,
                containerId: containerId
            },'/service/mg/con/report/loadContainerOrder/historyLis').then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
        })
    }
    handleRes(res){
        const {success,valid} = res;
        if(success&&valid){
            this.setState({
                loadingHistory:false,
                historyList:res.models||[]
            })
        }else{
            this.setState({
                loadingHistory:false,
            })
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    /**
     * 隐藏历史记录
     **/
    hideHistory(){
        this.setState({
            visible:false
        })
    }
    /**
     * 展示历史记录面板
     * @param item
     */
    showHistoryPanel(item){
        this.setState({
            visible:false,
        })
        if(this.props.showHistoryPanel)this.props.showHistoryPanel(item)
    }
    /**
     * 覆盖历史记录
     * @param item
     */
    recovery(item,recoverUrl){
        this.setState({
            loadingHistory: true
        })
        const postData = {
            id: item.id
        }
        ShipperManagementAction.autoFetchAction(postData,recoverUrl).then(res=>this.handleRecoveryRes(res.data)).catch(err=>this.handleRecoveryRes(err))

    }
    handleRecoveryRes(res){
        const {success,valid} = res;
        if(success&&valid){
            message.success(Lang({id:'CaoZuoChengGong',default: "操作成功",}));
            this.setState({
                visible:false,
                loadingHistory: false
            })
            if(this.props.recoveryHistoryBack)this.props.recoveryHistoryBack()
        }else{
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const  {title,className, orderType,containerId,showRecover,recoverUrl } = this.props;
        const {visible,loadingHistory,historyList } = this.state;
        return (<>
            <div className={className} onClick={()=>this.showHistory(orderType,containerId)}><i className='ri-file-history-line color-yellow mr_4'></i> {Lang({id: "LiShiJiLu",default: "历史记录"})}</div>
            {/*<Button className={className} onClick={()=>this.openDownLoadFlag(true)}>{title}</Button>*/}
            {/*历史记录*/}
            {visible&&<Modal title={title}
                             footer={<Button onClick={this.hideHistory.bind(this)}>{Lang({id:'QuXiao',default:'取消'})}</Button>}
                             onCancel={this.hideHistory.bind(this)}
                             open={visible}>
                <Spin spinning={loadingHistory}>
                    <div className="history-list">
                        <ul>
                            {historyList.map((item,index)=>{
                                return <li key={index}>
                                    <div>
                                        <div>{Lang({id:'BanBen',default:'版本'})}{item.version}</div>
                                        <div className="color-tip">{item.createTime?dayjs(item.createTime).format("YYYY-MM-DD"):"-"} {item.createBy}</div>
                                    </div>
                                    <div>
                                        {showRecover&&recoverUrl&&item.isNew!=1&&<Button className={"margin-right-5"}
                                                                          onClick={()=>this.recovery(item,recoverUrl)}>{Lang({id:'HuiFuCiBanBen',default:'恢复此版本'})}
                                        </Button>}
                                        {item.isNew==1&&<span className={"margin-right-5"}>{Lang({id:'DangQianBanBen',default:'当前版本'})}</span>}
                                        <Button type="primary" onClick={this.showHistoryPanel.bind(this,item)}>{Lang({id: 'View',default:'查看'})}</Button>
                                    </div>
                                </li>
                            })
                            }
                        </ul>
                    </div>
                </Spin>
            </Modal>}

        </>)
    }
}
